/**
 * useThemeVars — 把該遊戲的 themeColor / formulaColor 寫成 CSS 變數到 `:root`。
 *
 * # 為什麼寫 `documentElement` 而不是 `.responsive-card`
 *
 * `van-popup` 預設 `teleport="body"`,paytable / rules / history modal 都 render
 * 在 `<body>` 下(.responsive-card 的 DOM 樹外),CSS var 不會 cascade 過去。
 * 原本 `:style="cardThemeStyle"` 只影響 `.responsive-card` 自己內部元件,對
 * teleported popup 無效 → modal 內讀不到 themeColor。寫到 `:root` 全 DOM 樹都吃。
 *
 * # 兩個變數
 *
 *   `--color-theme`   ← chrome.themeColor   (PopupWrapper / SymbolGrid / RichLine 等)
 *   `--color-formula` ← chrome.formulaColor (RuleCompositeSection 內 formula / winExample)
 *
 * 沒設的 game 維持 `src/style.css` 全域 fallback:
 *   - `--color-theme: #ffffff`(白)
 *   - `--color-formula: #ecc24a`(金黃)
 *
 * # 進階用法
 *
 *   `formulaColor: 'var(--color-theme)'` → 讓 formula 顏色自動跟主題色同步
 *   (yyz3258 採此模式,paytable 的 formula 跟 themeColor 永遠一致)
 *
 * # 用法(App.vue)
 *
 *   useThemeVars(gameAssets)  // gameAssets 是 useGameId() 回傳的 ref
 */

import { watchEffect, type Ref } from 'vue'

interface ThemeAssets {
  themeColor?: string
  formulaColor?: string
}

export function useThemeVars(assets: Readonly<Ref<ThemeAssets>>): void {
  watchEffect(() => {
    const a = assets.value
    const root = document.documentElement
    if (a.themeColor) root.style.setProperty('--color-theme', a.themeColor)
    else root.style.removeProperty('--color-theme')
    if (a.formulaColor) root.style.setProperty('--color-formula', a.formulaColor)
    else root.style.removeProperty('--color-formula')
  })
}
